document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.inner-tab-button');
    const contents = document.querySelectorAll('.inner-tab-content');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const target = button.dataset.tab;

        buttons.forEach(btn => btn.classList.remove('active'));
        contents.forEach(content => content.classList.remove('active'));

        button.classList.add('active');
        document.getElementById(target).classList.add('active');
      });
    });
});

// dropdown menu 
document.addEventListener('DOMContentLoaded', () => {
       function adjustDropdownPosition(dropdown) {
        const rect = dropdown.getBoundingClientRect();
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth; // Use both for wider compatibility

        if (rect.right > viewportWidth) {
            dropdown.classList.add('flip-left');
        } else {
           if (dropdown.classList.contains('flip-left')) {
                dropdown.classList.remove('flip-left');
                const naturalRect = dropdown.getBoundingClientRect();
                if (naturalRect.right <= viewportWidth) {
                } else {
                    dropdown.classList.add('flip-left');
                }
            }
        }
    }

    document.querySelectorAll('.dropdown-parent').forEach(parentItem => {
        parentItem.addEventListener('mouseenter', () => {
            const submenu = parentItem.querySelector('.dropdown-menu, .dropdown-submenu');
            if (submenu) {
                requestAnimationFrame(() => {
                    adjustDropdownPosition(submenu);
                });
            }
        });

        parentItem.addEventListener('mouseleave', () => {
            const submenu = parentItem.querySelector('.dropdown-menu, .dropdown-submenu');
            if (submenu) {
                submenu.classList.remove('flip-left');
            }
        });

        parentItem.addEventListener('focusin', () => {
            const submenu = parentItem.querySelector('.dropdown-menu, .dropdown-submenu');
            if (submenu) {
                requestAnimationFrame(() => {
                    adjustDropdownPosition(submenu);
                });
            }
        });

        const parentDetails = parentItem.querySelector('details');
        if (parentDetails) {
            parentDetails.addEventListener('toggle', () => {
                const submenu = parentDetails.querySelector('.dropdown-menu'); // First level dropdown
                if (submenu && parentDetails.open) {
                    requestAnimationFrame(() => {
                        adjustDropdownPosition(submenu);
                    });
                }
            });
        }
    });

    window.addEventListener('resize', () => {
        document.querySelectorAll('.dropdown-menu, .dropdown-submenu').forEach(dropdown => {
            if (dropdown.offsetParent !== null) { 
                 requestAnimationFrame(() => {
                    adjustDropdownPosition(dropdown);
                });
            }
        });
    });
});

// mobile menu
document.addEventListener('DOMContentLoaded', function() {
    function toggleSubmenu(trigger) {
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', !isExpanded);
      
      const submenu = trigger.closest('.has-submenu').querySelector('.submenu');
      submenu.classList.toggle('active');
    }

    const toggles = document.querySelectorAll('.submenu-toggle');
    toggles.forEach(toggle => {
      toggle.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleSubmenu(this);
      });
    });

    const triggers = document.querySelectorAll('[data-submenu-trigger]');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        if (e.target.tagName === 'A' && e.target.getAttribute('href') !== '#') {
          return;
        }
        
        const toggle = this.querySelector('.submenu-toggle');
        if (toggle) {
          e.preventDefault();
          e.stopPropagation();
          toggleSubmenu(toggle);
        }
      });
    });
});
  // single posts bottom banner
if(counter===undefined){var counter=0;}(function(){if(counter===0){counter++;var i;var h="https://req.easywebinar.com/";var cdnurl="https://req.easywebinar.com";function f(k,j){if("js"==j){var l=document.createElement("script");l.type="text/javascript",l.src=k,document.body.appendChild(l)}else{if("css"==j){var l=document.createElement("link");l.rel="stylesheet",l.href=k,document.head.appendChild(l)}}}f(cdnurl+"/widget/css/ewp-widget.css?v=151","css");f(cdnurl+"/widget/phone-code/css/intlTelInput.css?v=143","css"); if(window.jQuery===undefined || jQuery.fn.jquery=='1.4.2'){var a=document.createElement("script");a.setAttribute("type","text/javascript");a.setAttribute("src","https://code.jquery.com/jquery-3.2.1.min.js");if(a.readyState){a.onreadystatechange=function(){if(this.readyState=="complete"||this.readyState=="loaded"){g()}}}else{a.onload=g}(document.getElementsByTagName("head")[0]||document.documentElement).appendChild(a)}else{i=window.jQuery;e()}function g(){i=window.jQuery;e()}function e(){ if(window.jstz===undefined){var j=document.createElement("script");j.setAttribute("type","text/javascript");j.setAttribute("src","https://cdnjs.cloudflare.com/ajax/libs/jstimezonedetect/1.0.4/jstz.min.js");if(j.readyState){j.onreadystatechange=function(){if(this.readyState=="complete"||this.readyState=="loaded"){d()}}}else{j.onload=d}(document.getElementsByTagName("head")[0]||document.documentElement).appendChild(j)}else{d()}}function c(j){if(j>=0){return(parseInt(j,10)<10?"0":"")+j}else{return(parseInt(Math.abs(j),10)<10?"0":"")+Math.abs(j)}}function b(){var k=new Date();var j=k.getTimezoneOffset();j=parseFloat((-1)*(parseInt(j,10)/60)).toFixed(2);var m=j.split(".");var l=c(m[0])+":"+c(parseInt((m[1]*60)/100,10))+":00";var n="";if(parseInt(m[0],10)>=0){n="+"}else{n="-"}return{tzVal:l,tzOp:n}}function d(){f(cdnurl+"/widget/phone-code/js/intlTelInput.min.js?v=143","js"); i(document).ready(function(o){var q=(jstz)?jstz.determine():null;var k=(q)?encodeURIComponent(o.trim(q.name())):"";var p=b().tzVal;var n=b().tzOp;var j=h+"/widget/widget.php";var l=function(){o("body").hasClass("ewp_updated")||m(),o("body").hasClass("ewp_script_loaded")||(o("body").addClass("ewp_script_loaded"),wrap_count=0,o(".widget_wrapper_btn").each(function(){var u=(o(this),o(this).find(".ewp_widget_container")),t=o(this).find(".ew-md-overlay").attr("overlay_id",wrap_count);u.attr("container_id",wrap_count),o("body").append(t),t.append(u),o(this).find(".ewp_widget_container").remove(),o(this).find(".ew-md-overlay").remove(),u=o("body").find("[container_id="+wrap_count+"]");var v=o(this).find(".ewp_widget_btnid");v.attr("btn_id",wrap_count),v.css("cursor","pointer");var s=(document.querySelector('.ew-md-overlay[overlay_id="'+wrap_count+'"]'),o(this).find(".ew-md-trigger"));[].slice.call(s).forEach(function(y,A){function w(){var r;r=classie.has(y,"ew-md-setperspective"),z.removeClass("ew-md-show"),r&&document.documentElement.removeClass("ew-md-perspective")}var x=document.querySelector('[btn_id="'+wrap_count+'"]'),z=u;x.addEventListener("click",function(D){o("body").append('<div class="ewp_loading_">Loading&#8230;</div>');o("body").addClass("ewp_noscroll");var C=o(this).attr("btn_id"),F=o("body").find("[container_id="+C+"]"),B=F.attr("webinar_id").replace(/\s/g,"+"),E=j+"?wid="+B+"&ver_cache="+(new Date).getTime()+"&user_timezone="+(k)+"&timezone_difference="+(p)+"&timezone_operation="+(n);F.addClass("ew-md-show"),F.removeClass("ew-thankyou"),F.find(".ew-md-content").load(E,function(r){o(".ewp_Wigloader_wrap").hide();o(".ewp_loading_").hide();o('.ew-md-overlay[overlay_id="'+C+'"]').addClass("activePopup"),F.on("click",".ew-md-overlay",function(G){G.target===this&&(o("body").removeClass("ewp_noscroll"),o(".ew-md-overlay").removeClass("activePopup"),o("body").removeClass("ewp_noscroll"),G.preventDefault(),G.stopPropagation(),w())}),F.on("click",".ew-md-close",function(G){o("body").removeClass("ewp_noscroll"),o(".ew-md-overlay").hasClass("activePopup")&&o(".ew-md-overlay").removeClass("activePopup"),G.preventDefault(),G.stopPropagation(),w()});F.on("keypress",".ewp_widget_container input",function(G){return 13==G.which?(F.children().find(".ewp_submit").click(),!1):void 0})}),D.stopPropagation()})}),wrap_count++}))}();!function(w){function x(t){return new RegExp("(^|\\s+)"+t+"(\\s+|$)")}function z(t,A){var B=r(t,A)?y:v;B(t,A)}var r,v,y;"classList" in document.documentElement?(r=function(t,A){return t.classList.contains(A)},v=function(t,A){t.classList.add(A)},y=function(t,A){t.classList.remove(A)}):(r=function(t,A){return x(A).test(t.className)},v=function(t,A){r(t,A)||(t.className=t.className+" "+A)},y=function(t,A){t.className=t.className.replace(x(A)," ")});var u={hasClass:r,addClass:v,removeClass:y,toggleClass:z,has:r,add:v,remove:y,toggle:z};"function"==typeof define&&define.amd?define(u):w.classie=u}(window);function m(){var x=o("#ewp_widget_btnid");if(x.length){o("body").addClass("ewp_updated");var v=o("#ewp_widget_container").attr("webinar_id");x.closest("#ewp_widget_container").remove();var u=x.next(),w=x.next().next(),y=w.next(),z=y.attr("src");u.remove(),y.remove(),w.remove(),newWidgetHTML='<div class="widget_wrapper_btn"><button style="display:none" class="ew-md-trigger ewp_widget_btnid loader"></button><div class="ew-md-modal ewp_widget_container ew-md-effect-19" webinar_id="'+v+'" ></div><div class="ew-md-overlay"></div> <script type="text/javascript" src="'+z+'" ><\/script></div>',x.after(newWidgetHTML),x.remove()}else{var s=o("#ewp_widget_container");if(s.length){o("body").addClass("ewp_updated");var v=o("#ewp_widget_container").attr("webinar_id"),y=o("#ewp_widget_container").next(),z=y.attr("src");y.remove(),newWidgetHTML='<div class="widget_wrapper"><div class="ewp_form_container ewp_widget_container" webinar_id="'+v+'" ></div> <script type="text/javascript" src="'+z+'"><\/script></div>',s.after(newWidgetHTML),s.remove()}}}o(".widget_wrapper_btn").length>=1&&o(".widget_wrapper_btn").each(function(){var x=o(this).find(".ewp_widget_btnid").attr("btn_id"),v=o("body").find("[container_id="+x+"]"),u=o(this).find(".ewp_widget_btnid"),w=v.attr("webinar_id").replace(/\s/g,"+"),y=j+"?wid="+w+"&design=1&ver_cache="+(new Date).getTime()+Math.random()+"&user_timezone="+(k)+"&timezone_difference="+(p)+"&timezone_operation="+(n);var s=o(this);/*o(".ewp_widget_btnid").show();*/if(!v.hasClass("ew-dont-iterate")){s.append('<div class="ewp_Wigloader_wrap"><div class="ew_loader ew_loader_green"></div></div>');v.addClass("ew-dont-iterate");o.getJSON(y,function(z){try{ var fonfamily=z.widget_font_family.replace(" ", "+");var link=document.createElement('link');link.setAttribute('rel','stylesheet');link.setAttribute('type','text/css');link.setAttribute('href','https://fonts.googleapis.com/css?family='+fonfamily);document.head.appendChild(link);u.show().text(z.widget_button_txt.replace(/\\/g,"")).css({"background-color":z.widget_button_bg_color,color:z.widget_button_color,"font-family":z.widget_font_family,"font-size":z.widget_font_size+"px",border:"none",height:z.widget_button_height?z.widget_button_height+"px":"44px",width:z.widget_button_width?z.widget_button_width+"px":"100px","min-width":"220px","border-radius":"5px"}).removeClass("loader"),"2"==z.widget_layout_type?v.addClass("oncol"):v.addClass("twocol"),v.html('<div class="ew-md-content"></div>');var t=z.widget_font_family,A=z.widget_font_family.replace(" ","+");s.find(".ewp_Wigloader_wrap").remove()}catch(z){s.find(".ewp_Wigloader_wrap").remove()}})}}),o(".widget_wrapper").length>=1&&o(".widget_wrapper").each(function(){var w=o(this),u=w.find(".ewp_widget_container"),s=u.attr("webinar_id").replace(/\s/g,"+"),v=j+"?wid="+s+"&ver_cache="+(new Date).getTime()+Math.random()+"&user_timezone="+(k)+"&timezone_difference="+(p)+"&timezone_operation="+(n);if(!u.hasClass("ew-dont-iterate")){w.append('<div class="ewp_Wigloader_wrap"><div class="ew_loader ew_loader_green"></div></div>');u.addClass("ew-dont-iterate");u.load(v,function(r){w.find(".ewp_Wigloader_wrap").remove();w.on("keypress",".ewp_widget_container input",function(t){return 13==t.which?(w.children().find(".ewp_submit").click(),!1):void 0})})}}),o(document).on("keypress",".ewp_widget_container input",function(s){var r=o(this).parents(".ew-md-show.ewp_widget_container:first").find(".ewp_submit");return 13==s.which?(r.click(),!1):void 0})})}}})();

  // books slider

document.addEventListener("DOMContentLoaded", function() {
  let slideIndex = 0;
  const slides = document.querySelectorAll("#carousel1 .slide");
  const prevBtn = document.querySelector("#carousel1 .prev");
  const nextBtn = document.querySelector("#carousel1 .next");
  let autoSlide;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.style.display = (i === index) ? "block" : "none";
    });
  }

  function nextSlide() {
    slideIndex = (slideIndex + 1) % slides.length;
    showSlide(slideIndex);
  }

  function prevSlide() {
    slideIndex = (slideIndex - 1 + slides.length) % slides.length;
    showSlide(slideIndex);
  }

  // Auto play function
  function startAutoSlide() {
    autoSlide = setInterval(nextSlide, 4000); // 4000ms = 4 seconds
  }

  function stopAutoSlide() {
    clearInterval(autoSlide);
  }

  // Button events (reset timer when clicked)
  prevBtn.addEventListener("click", function() {
    prevSlide();
    stopAutoSlide();
    startAutoSlide();
  });

  nextBtn.addEventListener("click", function() {
    nextSlide();
    stopAutoSlide();
    startAutoSlide();
  });

  // Init
  showSlide(slideIndex);
  startAutoSlide();
});


class PredictiveSearch extends HTMLElement 
  {
    constructor() {
      super();
      this.enabled = this.getAttribute('data-enabled');
      this.context = this.getAttribute('data-context');
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
      this.results = this.querySelector('#predictive-search');
      this.closeBtn = this.querySelector('.btn--close-search');
      this.screen = this.querySelector('[data-screen]');
      this.SearchModal = this.closest('#SearchModal') || null;
  
      // Open events
      document.addEventListener('predictive-search:open', e => {
        if (e.detail.context !== this.context) return;
        this.classList.add('is-active');
  
        // Wait for opening events to finish then apply focus
        setTimeout(() => { this.input.focus(); }, 100);
  
        document.body.classList.add('predictive-overflow-hidden');
      });
  
      // listen for class change of 'modal--is-active on this.SearchModal
      if (this.SearchModal) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class') {
              const modalClass = mutation.target.className;
              if (modalClass.indexOf('modal--is-active') > -1) {
                setTimeout(() => { this.input.focus(); }, 100);
              }
            }
          });
        });
  
        observer.observe(this.SearchModal, {
          attributes: true
        });
      }
  
      if (this.enabled === 'false') return;
  
      // On typing
      this.input.addEventListener('keydown', () => { this.classList.add('is-active'); });
  
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
  
      // Close events
      document.addEventListener('predictive-search:close', () => { this.close(); });
      document.addEventListener('keydown', (event) => { if (event.keyCode === 27) this.close(); });
      this.closeBtn.addEventListener('click', e => { e.preventDefault(); this.close(); });
      this.screen.addEventListener('click', () => { this.close(); });
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) return;
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      const searchObj = {
        'q': searchTerm,
        'resources[type]': 'product,article,page', // Ye line add ki hai taaki pages aur articles dono fetch hon
        'resources[limit]': 4,                      // Limit ko 3 se badha kar 4 kiya hai taaki content miss na ho
        'resources[limit_scope]': 'each'
      };
  
      const params = this.paramUrl(searchObj);
  
      fetch(`${theme.routes.predictiveSearch}?${params}&section_id=search-results`)
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-results').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
  
          AOS.refreshHard();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  
    open() {
      this.predictiveSearchResults.style.display = 'block';
    }
  
    close() {
      this.predictiveSearchResults.style.display = 'none';
      this.predictiveSearchResults.innerHTML = '';
      this.classList.remove('is-active');
      document.body.classList.remove('predictive-overflow-hidden');
  
      document.dispatchEvent(new CustomEvent('predictive-search:close-all'));
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  
    paramUrl(obj) {
      return Object.keys(obj).map(function(key) {
        return key + '=' + encodeURIComponent(obj[key]);
      }).join('&')
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);


(function () {
  function initArticleCarousel(scope = document) {

    const sliders = scope.querySelectorAll(".article-product-carousel");

    sliders.forEach(function (slider) {

      if (slider.dataset.initialized === "true") return;
      slider.dataset.initialized = "true";

      const slides = slider.querySelectorAll(".slide");
      if (!slides.length) return;

      const prev = slider.querySelector(".prev");
      const next = slider.querySelector(".next");

      const settings = {
        autoplay: slider.dataset.autoplay === "true",
        speed: parseInt(slider.dataset.speed, 10) || 4000,
        pauseHover: slider.dataset.pauseHover === "true",
        navigation: slider.dataset.navigation === "true"
      };

      let current = 0;
      let timer = null;

      function render() {

        slides.forEach(function(slide,index){

          slide.classList.toggle("active",index===current);
          slide.style.display=index===current?"block":"none";

        });

      }

      function nextSlide(){

        current=(current+1)%slides.length;
        render();

      }

      function prevSlide(){

        current=(current-1+slides.length)%slides.length;
        render();

      }

      function stop(){

        if(timer){

          clearInterval(timer);
          timer=null;

        }

      }

      function start(){

        stop();

        if(!settings.autoplay) return;
        if(slides.length<2) return;

        timer=setInterval(nextSlide,settings.speed);

      }

      render();

      if(settings.navigation && slides.length>1){

        if(prev){

          prev.style.display="flex";

          prev.addEventListener("click",function(){

            prevSlide();
            start();

          });

        }

        if(next){

          next.style.display="flex";

          next.addEventListener("click",function(){

            nextSlide();
            start();

          });

        }

      }else{

        if(prev) prev.style.display="none";
        if(next) next.style.display="none";

      }

      if(settings.pauseHover){

        slider.addEventListener("mouseenter",stop);
        slider.addEventListener("mouseleave",start);

      }

      let startX=0;

      slider.addEventListener("touchstart",function(e){

        startX=e.changedTouches[0].clientX;

      },{passive:true});

      slider.addEventListener("touchend",function(e){

        const endX=e.changedTouches[0].clientX;

        if(Math.abs(startX-endX)<40) return;

        if(startX>endX){

          nextSlide();

        }else{

          prevSlide();

        }

        start();

      },{passive:true});

      start();

    });

  }

  document.addEventListener("DOMContentLoaded",function(){

    initArticleCarousel();

  });

  document.addEventListener("shopify:section:load",function(e){

    initArticleCarousel(e.target);

  });

  document.addEventListener("shopify:section:reorder",function(e){

    initArticleCarousel(e.target);

  });

  document.addEventListener("shopify:block:select",function(e){

    initArticleCarousel(e.target);

  });

})();



/*==================================================
PCG CUSTOM ARTICLE GUIDE
==================================================*/

(function () {

    function initArticleGuide(section) {

        if (!section) return;

        initFAQ(section);
        initTOC(section);
        initProductSlider(section);

    }

    /*==================================================
    FAQ
    ==================================================*/

    function initFAQ(section) {

        const items = section.querySelectorAll(
            ".pcg-custom-article-guide-faq-item"
        );

        items.forEach((item) => {

            const button = item.querySelector(
                ".pcg-custom-article-guide-faq-button"
            );

            if (!button) return;

            button.addEventListener("click", function () {

                const isOpen = item.classList.contains("is-open");

                items.forEach((faq) => {

                    faq.classList.remove("is-open");

                    const btn = faq.querySelector(
                        ".pcg-custom-article-guide-faq-button"
                    );

                    if (btn) {
                        btn.setAttribute("aria-expanded", "false");
                    }

                });

                if (!isOpen) {

                    item.classList.add("is-open");

                    button.setAttribute("aria-expanded", "true");

                }

            });

        });

    }

    /*==================================================
    TOC
    ==================================================*/

    function initTOC(section) {

        const toc = section.querySelector(
            "#pcg-custom-article-guide-toc"
        );

        if (!toc) return;

        const headings = section.querySelectorAll(
            ".pcg-custom-article-guide-step-card-title"
        );

        if (!headings.length) return;

        toc.innerHTML = "";

        headings.forEach((heading, index) => {

            const article = heading.closest(
                ".pcg-custom-article-guide-step-card"
            );

            if (!article) return;

            if (!article.id) {
                article.id =
                    "pcg-custom-article-guide-step-" + (index + 1);
            }

            const link = document.createElement("a");

            link.href = "#" + article.id;

            link.textContent = heading.textContent;

            toc.appendChild(link);

        });

        const links = toc.querySelectorAll("a");

        window.addEventListener("scroll", function () {

            let current = "";

            headings.forEach((heading) => {

                const card = heading.closest(
                    ".pcg-custom-article-guide-step-card"
                );

                if (!card) return;

                const top = card.getBoundingClientRect().top;

                if (top <= 150) {
                    current = card.id;
                }

            });

            links.forEach((link) => {

                link.classList.remove("active");

                if (
                    link.getAttribute("href") === "#" + current
                ) {

                    link.classList.add("active");

                }

            });

        });

    }

    /*==================================================
    PRODUCT SLIDER
    ==================================================*/

    function initProductSlider(section) {

        if (typeof Swiper === "undefined") return;

        const slider = section.querySelector(
            ".pcg-custom-article-guide-related-products-slider"
        );

        if (!slider) return;

        if (slider.classList.contains("swiper-initialized")) return;

        new Swiper(slider, {

            slidesPerView: 1,

            spaceBetween: 20,

            pagination: {

                el: slider.querySelector(
                    ".swiper-pagination"
                ),

                clickable: true

            },

            breakpoints: {

                640: {

                    slidesPerView: 2

                },

                990: {

                    slidesPerView: 1

                }

            }

        });

    }

    /*==================================================
    INITIAL LOAD
    ==================================================*/

    document.addEventListener("DOMContentLoaded", function () {

        document
            .querySelectorAll(".pcg-custom-article-guide-section")
            .forEach(function (section) {

                initArticleGuide(section);

            });

    });

    /*==================================================
    SHOPIFY THEME EDITOR
    ==================================================*/

    document.addEventListener("shopify:section:load", function (event) {

        initArticleGuide(event.target);

    });

})();


document.addEventListener("DOMContentLoaded", function () {

  const selectors = [
    ".article-contents",
    ".article-guide-care",
  ];

  let allText = "";

  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      allText += " " + el.innerText;
    });
  });

  const words = allText.trim().split(/\s+/).filter(Boolean).length;
  const readTime = Math.max(1, Math.ceil(words / 150));

  document.querySelectorAll(".article-read-time").forEach(el => {
    el.textContent = `${readTime} min read`;
  });

});

document.addEventListener("DOMContentLoaded", () => {

  const cards = document.querySelectorAll(".article-step-card");

  if (!cards.length) return;

  function updateTimeline() {

    cards.forEach((card, index) => {

      const line = card.querySelector(".step-line");
      if (!line) return;

      if (index === cards.length - 1) {

        const rect = card.getBoundingClientRect();

        const progress = Math.min(
          Math.max((window.innerHeight * 0.6 - rect.top), 0),
          card.offsetHeight
        );

        line.style.height = Math.max(progress - 38, 0) + "px";
        return;
      }

      const nextCard = cards[index + 1];

      const currentCircle = card.querySelector(".step-circle");
      const nextCircle = nextCard.querySelector(".step-circle");

      if (!currentCircle || !nextCircle) return;

      const currentRect = currentCircle.getBoundingClientRect();
      const nextRect = nextCircle.getBoundingClientRect();

      const distance =
        nextRect.top - currentRect.top - currentCircle.offsetHeight;

      line.style.height =
        currentRect.top < window.innerHeight * 0.5
          ? distance + "px"
          : "0px";
    });

  }

  updateTimeline();

  window.addEventListener("scroll", updateTimeline);
  window.addEventListener("resize", updateTimeline);

});


(function () {
  'use strict';

  /* =========================================================
   * PRODUCT CONTENT V1
   * SLIDER ENGINE
   *
   * Supports:
   * - Previous / Next buttons
   * - Mouse click + drag
   * - Touch swipe
   * - Trackpad / horizontal wheel
   * - Vertical mouse wheel converted to horizontal scroll
   * - Autoplay
   * - Keyboard focus handling
   * - Reduced motion
   * - Shopify section reload
   *
   * Sliders:
   * - Works Well With
   * - Continue Exploring
   * - Propagation Methods
   * ========================================================= */

  var sliders = [];
  var globalEventsInitialized = false;

  /* =========================================================
     REDUCED MOTION
  ========================================================= */

  var motionQuery =
    window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;

  function reducedMotion() {
    return motionQuery && motionQuery.matches;
  }

  /* =========================================================
     REGISTER SLIDER
  ========================================================= */

  function registerSlider(slider) {
    if (!slider) {
      return;
    }

    if (sliders.indexOf(slider) === -1) {
      sliders.push(slider);
    }
  }

  /* =========================================================
     REMOVE SLIDER
  ========================================================= */

  function removeSlider(slider) {
    var index = sliders.indexOf(slider);

    if (index !== -1) {
      sliders.splice(index, 1);
    }
  }

  /* =========================================================
     CLEAN SLIDERS
  ========================================================= */

  function cleanupSliders() {
    sliders = sliders.filter(function (slider) {
      return (
        slider &&
        slider.viewport &&
        document.documentElement.contains(slider.viewport)
      );
    });
  }

  /* =========================================================
     INITIALIZE PRODUCT CONTENT SLIDERS
  ========================================================= */

  function initProductContentSliders(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }

    /* =====================================================
       WORKS WELL WITH
    ===================================================== */

    var productSliders =
      root.querySelectorAll('[data-product-slider]');

    productSliders.forEach(function (viewport) {
      if (viewport.dataset.initialized === 'true') {
        return;
      }

      var track =
        viewport.querySelector(
          '.product-content-v1__products'
        );

      if (!track) {
        return;
      }

      var wrapper =
        viewport.closest(
          '.product-content-v1__works-with'
        );

      var prevButton =
        wrapper
          ? wrapper.querySelector(
              '.product-content-v1__slider-arrow--prev'
            )
          : null;

      var nextButton =
        wrapper
          ? wrapper.querySelector(
              '.product-content-v1__slider-arrow--next'
            )
          : null;

      viewport.dataset.initialized = 'true';

      createSlider({
        viewport: viewport,
        track: track,
        prevButton: prevButton,
        nextButton: nextButton
      });
    });

    /* =====================================================
       CONTINUE EXPLORING
    ===================================================== */

    var articleSliders =
      root.querySelectorAll('[data-article-slider]');

    articleSliders.forEach(function (viewport) {
      if (viewport.dataset.initialized === 'true') {
        return;
      }

      var track =
        viewport.querySelector(
          '.product-content-v1__articles'
        );

      if (!track) {
        return;
      }

      var wrapper =
        viewport.closest(
          '.product-content-v1__related-content'
        );

      var prevButton =
        wrapper
          ? wrapper.querySelector(
              '.product-content-v1__related-arrow--prev'
            )
          : null;

      var nextButton =
        wrapper
          ? wrapper.querySelector(
              '.product-content-v1__related-arrow--next'
            )
          : null;

      viewport.dataset.initialized = 'true';

      createSlider({
        viewport: viewport,
        track: track,
        prevButton: prevButton,
        nextButton: nextButton
      });
    });

    /* =====================================================
       PROPAGATION METHODS
       Uses existing classes + data attributes
    ===================================================== */

    var propagationSliders =
      root.querySelectorAll(
        '[data-propagation-slider]'
      );

    propagationSliders.forEach(function (wrapper) {
      /*
       * Only initialize the slider when the Liquid
       * section has enabled the desktop slider AND
       * there are more than 6 blocks.
       *
       * The class is already added by Liquid:
       *
       * .propagation-methods__cards-wrapper--slider
       */

      if (
        wrapper.dataset.initialized === 'true' ||
        !wrapper.classList.contains(
          'propagation-methods__cards-wrapper--slider'
        )
      ) {
        return;
      }

      /*
       * The .propagation-methods__cards element
       * is the actual horizontal scrolling viewport.
       */

      var viewport =
        wrapper.querySelector(
          '[data-propagation-slider-track]'
        );

      if (!viewport) {
        return;
      }

      /*
       * Buttons are already inside the wrapper.
       */

      var prevButton =
        wrapper.querySelector(
          '[data-propagation-slider-prev]'
        );

      var nextButton =
        wrapper.querySelector(
          '[data-propagation-slider-next]'
        );

      /*
       * The Propagation Methods Liquid places
       * autoplay data on the wrapper.
       *
       * The generic slider reads autoplay data
       * from the viewport.
       *
       * Copy the values before initialization.
       */

      viewport.dataset.autoplay =
        wrapper.dataset.autoplay || 'false';

      viewport.dataset.autoplaySpeed =
        wrapper.dataset.autoplaySpeed || '4000';

      wrapper.dataset.initialized = 'true';

      /*
       * In Propagation Methods:
       *
       * viewport = .propagation-methods__cards
       * track    = .propagation-methods__cards
       *
       * This is intentional because the cards container
       * itself is the horizontal scrolling element.
       */

      createSlider({
        viewport: viewport,
        track: viewport,
        prevButton: prevButton,
        nextButton: nextButton
      });
    });

    cleanupSliders();
  }

  /* =========================================================
     GENERIC SLIDER
  ========================================================= */

  function createSlider(options) {
    var viewport = options.viewport;
    var track = options.track;
    var prevButton = options.prevButton;
    var nextButton = options.nextButton;

    if (!viewport || !track) {
      return;
    }

    var autoplayEnabled =
      viewport.dataset.autoplay === 'true';

    var autoplaySpeed =
      parseInt(
        viewport.dataset.autoplaySpeed,
        10
      ) || 4000;

    var autoplayTimer = null;

    /* =====================================================
       DRAG STATE
    ===================================================== */

    var isDragging = false;
    var hasDragged = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;
    var dragPointerId = null;
    var dragThreshold = 5;

    /* =====================================================
       GET STEP
    ===================================================== */

    function getStep() {
      var card =
        track.querySelector(':scope > *');

      if (!card) {
        return viewport.clientWidth;
      }

      var trackStyles =
        window.getComputedStyle(track);

      var gap =
        parseFloat(
          trackStyles.columnGap ||
          trackStyles.gap ||
          0
        );

      return (
        card.getBoundingClientRect().width +
        gap
      );
    }

    /* =====================================================
       MAX SCROLL
    ===================================================== */

    function getMaxScroll() {
      return Math.max(
        0,
        viewport.scrollWidth -
          viewport.clientWidth
      );
    }

    /* =====================================================
       UPDATE BUTTONS
    ===================================================== */

    function updateButtons() {
      var maxScroll =
        getMaxScroll();

      var canScroll =
        maxScroll > 1;

      if (prevButton) {
        prevButton.disabled =
          !canScroll ||
          viewport.scrollLeft <= 1;
      }

      if (nextButton) {
        nextButton.disabled =
          !canScroll ||
          viewport.scrollLeft >=
            maxScroll - 1;
      }
    }

    /* =====================================================
       SCROLL TO START
    ===================================================== */

    function scrollToStart() {
      viewport.scrollTo({
        left: 0,
        behavior:
          reducedMotion()
            ? 'auto'
            : 'smooth'
      });
    }

    /* =====================================================
       NEXT
    ===================================================== */

    function goToNext() {
      var maxScroll =
        getMaxScroll();

      if (maxScroll <= 1) {
        return;
      }

      if (
        viewport.scrollLeft >=
        maxScroll - 2
      ) {
        scrollToStart();
        return;
      }

      viewport.scrollBy({
        left: getStep(),
        behavior:
          reducedMotion()
            ? 'auto'
            : 'smooth'
      });
    }

    /* =====================================================
       PREVIOUS
    ===================================================== */

    function goToPrevious() {
      viewport.scrollBy({
        left: -getStep(),
        behavior:
          reducedMotion()
            ? 'auto'
            : 'smooth'
      });
    }

    /* =====================================================
       STOP AUTOPLAY
    ===================================================== */

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(
          autoplayTimer
        );

        autoplayTimer = null;
      }
    }

    /* =====================================================
       START AUTOPLAY
    ===================================================== */

    function startAutoplay() {
      stopAutoplay();

      if (
        !autoplayEnabled ||
        reducedMotion() ||
        getMaxScroll() <= 1 ||
        document.hidden
      ) {
        return;
      }

      autoplayTimer =
        window.setInterval(
          function () {
            goToNext();
          },
          autoplaySpeed
        );
    }

    /* =====================================================
       BUTTONS
    ===================================================== */

    if (prevButton) {
      prevButton.addEventListener(
        'click',
        function () {
          goToPrevious();
          startAutoplay();
        }
      );
    }

    if (nextButton) {
      nextButton.addEventListener(
        'click',
        function () {
          goToNext();
          startAutoplay();
        }
      );
    }

    /* =====================================================
       POINTER DOWN
    ===================================================== */

    viewport.addEventListener(
      'pointerdown',
      function (event) {
        if (
          event.pointerType === 'mouse' &&
          event.button !== 0
        ) {
          return;
        }

        if (
          event.target.closest(
            'button, input, select, textarea, form, a'
          )
        ) {
          return;
        }

        isDragging = true;
        hasDragged = false;

        dragPointerId =
          event.pointerId;

        dragStartX =
          event.clientX;

        dragStartScrollLeft =
          viewport.scrollLeft;

        stopAutoplay();

        if (
          viewport.setPointerCapture
        ) {
          try {
            viewport.setPointerCapture(
              event.pointerId
            );
          } catch (error) {}
        }
      }
    );

    /* =====================================================
       POINTER MOVE
    ===================================================== */

    viewport.addEventListener(
      'pointermove',
      function (event) {
        if (
          !isDragging ||
          event.pointerId !== dragPointerId
        ) {
          return;
        }

        var deltaX =
          event.clientX -
          dragStartX;

        if (
          Math.abs(deltaX) >
          dragThreshold
        ) {
          hasDragged = true;
        }

        if (!hasDragged) {
          return;
        }

        event.preventDefault();

        viewport.scrollLeft =
          dragStartScrollLeft -
          deltaX;
      },
      {
        passive: false
      }
    );

    /* =====================================================
       POINTER UP / CANCEL
    ===================================================== */

    function finishPointerDrag(event) {
      if (
        !isDragging ||
        (
          dragPointerId !== null &&
          event.pointerId !== dragPointerId
        )
      ) {
        return;
      }

      isDragging = false;

      if (hasDragged) {
        viewport.dataset.dragged =
          'true';

        window.setTimeout(
          function () {
            viewport.dataset.dragged =
              'false';
          },
          100
        );
      }

      dragPointerId = null;

      updateButtons();
      startAutoplay();
    }

    viewport.addEventListener(
      'pointerup',
      finishPointerDrag
    );

    viewport.addEventListener(
      'pointercancel',
      finishPointerDrag
    );

    /* =====================================================
       PREVENT CLICK AFTER DRAG
    ===================================================== */

    viewport.addEventListener(
      'click',
      function (event) {
        if (
          viewport.dataset.dragged === 'true'
        ) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    /* =====================================================
       SCROLL
    ===================================================== */

    viewport.addEventListener(
      'scroll',
      function () {
        updateButtons();
      },
      {
        passive: true
      }
    );

    /* =====================================================
       MOUSE ENTER
    ===================================================== */

    viewport.addEventListener(
      'mouseenter',
      function () {
        stopAutoplay();
      }
    );

    /* =====================================================
       MOUSE LEAVE
    ===================================================== */

    viewport.addEventListener(
      'mouseleave',
      function () {
        if (!isDragging) {
          startAutoplay();
        }
      }
    );

    /* =====================================================
       KEYBOARD FOCUS
    ===================================================== */

    viewport.addEventListener(
      'focusin',
      function () {
        stopAutoplay();
      }
    );

    viewport.addEventListener(
      'focusout',
      function (event) {
        if (
          !viewport.contains(
            event.relatedTarget
          )
        ) {
          startAutoplay();
        }
      }
    );

    /* =====================================================
       TOUCH
    ===================================================== */

    viewport.addEventListener(
      'touchstart',
      function () {
        stopAutoplay();
      },
      {
        passive: true
      }
    );

    viewport.addEventListener(
      'touchend',
      function () {
        window.setTimeout(
          function () {
            startAutoplay();
          },
          500
        );
      },
      {
        passive: true
      }
    );

    /* =====================================================
       WHEEL
    ===================================================== */

    viewport.addEventListener(
      'wheel',
      function (event) {
        var maxScroll =
          getMaxScroll();

        if (maxScroll <= 1) {
          return;
        }

        /* -----------------------------------------------
           Horizontal trackpad movement
        ----------------------------------------------- */

        if (
          Math.abs(event.deltaX) >
          Math.abs(event.deltaY)
        ) {
          stopAutoplay();

          window.setTimeout(
            startAutoplay,
            700
          );

          return;
        }

        /* -----------------------------------------------
           Vertical wheel -> horizontal movement
        ----------------------------------------------- */

        if (
          Math.abs(event.deltaY) >
          Math.abs(event.deltaX)
        ) {
          var currentScroll =
            viewport.scrollLeft;

          var direction =
            event.deltaY > 0
              ? 1
              : -1;

          var canMoveForward =
            direction > 0 &&
            currentScroll < maxScroll;

          var canMoveBackward =
            direction < 0 &&
            currentScroll > 0;

          if (
            canMoveForward ||
            canMoveBackward
          ) {
            event.preventDefault();

            stopAutoplay();

            viewport.scrollBy({
              left: event.deltaY,
              behavior: 'auto'
            });

            window.setTimeout(
              startAutoplay,
              700
            );
          }
        }
      },
      {
        passive: false
      }
    );

    /* =====================================================
       DESTROY
    ===================================================== */

    function destroy() {
      stopAutoplay();
      removeSlider(sliderInstance);
    }

    /* =====================================================
       SLIDER INSTANCE
    ===================================================== */

    var sliderInstance = {
      viewport: viewport,
      track: track,
      updateButtons: updateButtons,
      startAutoplay: startAutoplay,
      stopAutoplay: stopAutoplay,
      destroy: destroy
    };

    registerSlider(sliderInstance);

    /* =====================================================
       INITIALIZE
    ===================================================== */

    updateButtons();
    startAutoplay();
  }

  /* =========================================================
     GLOBAL RESIZE
     ONE LISTENER FOR ALL SLIDERS
  ========================================================= */

  function handleResize() {
    cleanupSliders();

    sliders.forEach(function (slider) {
      slider.updateButtons();
      slider.startAutoplay();
    });
  }

  /* =========================================================
     GLOBAL VISIBILITY
  ========================================================= */

  function handleVisibilityChange() {
    cleanupSliders();

    sliders.forEach(function (slider) {
      if (document.hidden) {
        slider.stopAutoplay();
      } else {
        slider.startAutoplay();
      }
    });
  }

  /* =========================================================
     REDUCED MOTION CHANGE
  ========================================================= */

  function handleMotionChange() {
    cleanupSliders();

    sliders.forEach(function (slider) {
      if (reducedMotion()) {
        slider.stopAutoplay();
      } else {
        slider.startAutoplay();
      }
    });
  }

  /* =========================================================
     INITIALIZE GLOBAL EVENTS
  ========================================================= */

  function initGlobalEvents() {
    if (globalEventsInitialized) {
      return;
    }

    globalEventsInitialized = true;

    var resizeTimer = null;

    window.addEventListener(
      'resize',
      function () {
        if (resizeTimer) {
          window.clearTimeout(
            resizeTimer
          );
        }

        resizeTimer =
          window.setTimeout(
            function () {
              handleResize();
            },
            100
          );
      }
    );

    document.addEventListener(
      'visibilitychange',
      handleVisibilityChange
    );

    if (motionQuery) {
      if (
        motionQuery.addEventListener
      ) {
        motionQuery.addEventListener(
          'change',
          handleMotionChange
        );
      } else if (
        motionQuery.addListener
      ) {
        motionQuery.addListener(
          handleMotionChange
        );
      }
    }
  }

  /* =========================================================
     INITIAL LOAD
  ========================================================= */

  function init() {
    initGlobalEvents();

    initProductContentSliders(
      document
    );
  }

  /* =========================================================
     DOM READY
  ========================================================= */

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
  

  /* =========================================================
     SHOPIFY SECTION LOAD
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initProductContentSliders(
        event.target
      );
    }
  );

})();


(function () {
  'use strict';

  const SECTION_SELECTOR = '[id^="general-product-faq-"]';
  const GROUP_SELECTOR =
    '.general-product-faq__step-cards[data-category-id="wholesale"]';
  const CARD_SELECTOR = '.steps-item-card';
  const NUMBER_SELECTOR = '.steps-item-card__number';
  const MOBILE_QUERY = '(max-width: 749px)';
  const STYLE_ID = 'faq-wholesale-step-connector-styles';

  const initializedSections = new WeakMap();
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  /* Inject CSS once */
  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = `
      @media (max-width: 749px) {
        ${GROUP_SELECTOR} {
          grid-template-columns: minmax(0, 1fr) !important;
          row-gap: 34px !important;
        }

        ${GROUP_SELECTOR}
        .steps-item-card .step-line[data-direction="vertical"] {
          width: 3px !important;
          min-width: 3px !important;
          height: auto;
          padding: 0 !important;
          margin: 0 !important;
          border: 0 !important;
          border-radius: 0 !important;
          box-shadow: none !important;
          color: transparent !important;
          font-size: 0 !important;
          line-height: 0 !important;
          background-color: transparent !important;
          background-image: radial-gradient(
            circle,
            #385844 1.5px,
            transparent 1.7px
          ) !important;
          background-size: 3px 10px !important;
          background-repeat: repeat-y !important;
          background-position: 0 0;
          pointer-events: none;
          z-index: 5;
          transform: translateX(-50%) !important;
        }

        ${GROUP_SELECTOR}
        .steps-item-card.is-hovered
        .step-line[data-direction="vertical"] {
          animation: faq-wholesale-dots 0.5s linear infinite;
        }

        @keyframes faq-wholesale-dots {
          from { background-position: 0 0; }
          to { background-position: 0 10px; }
        }
      }

      ${GROUP_SELECTOR}
      .steps-item-card .step-line[data-direction="horizontal"] {
        pointer-events: none;
      }

      ${GROUP_SELECTOR}
      .steps-item-card.is-hovered
      .step-line[data-direction="horizontal"] {
        animation: faq-wholesale-arrow 0.3s steps(1, end) infinite;
      }

      @keyframes faq-wholesale-arrow {
        0% { content: ""; }
      }

      @media (prefers-reduced-motion: reduce) {
        ${GROUP_SELECTOR} .step-line {
          animation: none !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function stopAnimation(card) {
    if (!card) return;

    card.classList.remove('is-hovered');

    const line = card._stepLine;
    if (!line) return;

    line._animating = false;

    if (line._timer) {
      clearTimeout(line._timer);
      line._timer = null;
    }

    if (line.dataset.direction === 'vertical') {
      line.style.animation = 'none';
      line.style.backgroundPosition = '0 0';
    } else {
      line.textContent = '··>';
    }
  }

  /* Hover effect applies to every card, including the last card. */
  function startAnimation(card) {
    if (!card || !card.isConnected) return;

    // Apply hover effect before checking for a connector.
    card.classList.add('is-hovered');

    // Last card has no next-step line, but keeps its hover effect.
    const line = card._stepLine;
    if (!line || !line.isConnected || reducedMotion.matches) return;

    if (line.dataset.direction === 'vertical') {
      line.style.removeProperty('animation');
      line.style.removeProperty('background-position');
      return;
    }

    if (line._animating) return;

    line._animating = true;
    const frames = ['··>', '>··', '·>·'];
    let frame = 0;

    function animate() {
      if (
        !line._animating ||
        !line.isConnected ||
        !card.classList.contains('is-hovered')
      ) {
        line._animating = false;
        line._timer = null;
        return;
      }

      line.textContent = frames[++frame % frames.length];
      line._timer = window.setTimeout(animate, 300);
    }

    line._timer = window.setTimeout(animate, 300);
  }

  function removeConnectors(cards) {
    cards.forEach(function (card) {
      card.querySelectorAll('.step-line').forEach(function (line) {
        line._animating = false;

        if (line._timer) {
          clearTimeout(line._timer);
          line._timer = null;
        }

        line.remove();
      });

      card._stepLine = null;
      card.classList.remove('has-step-connector');
    });
  }

  function createConnector(currentCard, nextCard, mobile) {
    const currentRect = currentCard.getBoundingClientRect();
    const nextRect = nextCard.getBoundingClientRect();

    const sameRow = Math.abs(currentRect.top - nextRect.top) < 4;
    const nextIsBelow = nextRect.top > currentRect.top + 4;

    if (mobile && !nextIsBelow) return null;
    if (!mobile && !sameRow) return null;

    const line = document.createElement('span');
    line.className = 'step-line';
    line.setAttribute('aria-hidden', 'true');
    line.dataset.direction = mobile ? 'vertical' : 'horizontal';
    line.textContent = mobile ? '' : '··>';

    Object.assign(line.style, {
      position: 'absolute',
      display: mobile ? 'block' : 'inline-flex',
      margin: '0',
      padding: '0',
      border: '0',
      background: 'transparent',
      boxShadow: 'none',
      zIndex: '5',
      pointerEvents: 'none'
    });

    if (getComputedStyle(currentCard).position === 'static') {
      currentCard.style.position = 'relative';
      currentCard.dataset.stepPositionAdded = 'true';
    }

    if (mobile) {
      const currentNumber = currentCard.querySelector(NUMBER_SELECTOR);
      const nextNumber = nextCard.querySelector(NUMBER_SELECTOR);

      const currentNumberRect = currentNumber
        ? currentNumber.getBoundingClientRect()
        : null;

      const nextNumberRect = nextNumber
        ? nextNumber.getBoundingClientRect()
        : null;

      const startX = currentNumberRect
        ? currentNumberRect.left + currentNumberRect.width / 2
        : currentRect.left + currentRect.width / 2;

      const startY = currentNumberRect
        ? currentNumberRect.bottom
        : currentRect.bottom;

      const endY = nextNumberRect
        ? nextNumberRect.top
        : nextRect.top;

      Object.assign(line.style, {
        left: (startX - currentRect.left) + 'px',
        top: (startY - currentRect.top) + 'px',
        width: '3px',
        height: Math.max(0, endY - startY) + 'px',
        transform: 'translateX(-50%)'
      });
    } else {
      const left =
        ((currentRect.right + nextRect.left) / 2) - currentRect.left;

      Object.assign(line.style, {
        width: '34px',
        height: '24px',
        left: left + 'px',
        top: '15px',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#8a9690',
        fontSize: '18px',
        lineHeight: '1',
        fontWeight: '500',
        whiteSpace: 'nowrap',
        transform: 'translate(-50%, -50%)'
      });
    }

    currentCard.appendChild(line);
    currentCard._stepLine = line;

    return line;
  }

  function updateGroup(data) {
    if (!data.group.isConnected) return;

    const mobile = isMobile();

    const hoveredCard = data.cards.find(function (card) {
      return card.classList.contains('is-hovered');
    });

    data.group.style.setProperty(
      'grid-template-columns',
      mobile ? 'minmax(0, 1fr)' : '',
      mobile ? 'important' : ''
    );

    if (mobile) {
      data.group.style.setProperty('row-gap', '34px', 'important');
    } else {
      data.group.style.removeProperty('row-gap');
    }

    removeConnectors(data.cards);

    // No connectors are created when steps are disabled or only one card exists.
    if (!data.stepEnabled || data.cards.length < 2) {
      if (hoveredCard) hoveredCard.classList.add('is-hovered');
      return;
    }

    // Create connectors only between cards.
    // The last card intentionally has no outgoing connector.
    for (let i = 0; i < data.cards.length - 1; i++) {
      const line = createConnector(
        data.cards[i],
        data.cards[i + 1],
        mobile
      );

      if (line) {
        data.cards[i].classList.add('has-step-connector');
      }
    }

    if (hoveredCard) startAnimation(hoveredCard);
  }

  function initSection(section) {
    if (!section || initializedSections.has(section)) return;

    const groups = section.querySelectorAll(GROUP_SELECTOR);
    if (!groups.length) return;

    const groupData = [];
    let resizeFrame = 0;

    function scheduleUpdate(data) {
      if (resizeFrame) cancelAnimationFrame(resizeFrame);

      resizeFrame = requestAnimationFrame(function () {
        resizeFrame = 0;
        updateGroup(data);
      });
    }

    groups.forEach(function (group) {
      const cards = Array.from(group.querySelectorAll(CARD_SELECTOR));
      if (!cards.length) return;

      const data = {
        group: group,
        cards: cards,
        stepEnabled: group.dataset.stepEnabled === 'true',
        observer: null
      };

      groupData.push(data);

      cards.forEach(function (card) {
        const number = card.querySelector(NUMBER_SELECTOR);

        if (number) {
          number.style.display = data.stepEnabled ? 'inline-flex' : 'none';
        }

        function activate() {
          if (!data.stepEnabled) return;

          cards.forEach(function (otherCard) {
            if (otherCard !== card) stopAnimation(otherCard);
          });

          startAnimation(card);
        }

        function deactivate() {
          stopAnimation(card);
        }

        card.addEventListener('mouseenter', activate);
        card.addEventListener('mouseleave', deactivate);
        card.addEventListener('focusin', activate);
        card.addEventListener('focusout', deactivate);
        card.addEventListener('touchstart', activate, { passive: true });
        card.addEventListener('touchend', deactivate, { passive: true });
        card.addEventListener('touchcancel', deactivate, { passive: true });
      });

      updateGroup(data);

      if ('ResizeObserver' in window) {
        data.observer = new ResizeObserver(function () {
          scheduleUpdate(data);
        });

        data.observer.observe(group);

        cards.forEach(function (card) {
          data.observer.observe(card);
        });
      }
    });

    let resizeTimer = 0;

    function onResize() {
      clearTimeout(resizeTimer);

      resizeTimer = window.setTimeout(function () {
        groupData.forEach(function (data) {
          scheduleUpdate(data);
        });
      }, 150);
    }

    window.addEventListener('resize', onResize, { passive: true });

    initializedSections.set(section, function cleanup() {
      clearTimeout(resizeTimer);

      if (resizeFrame) cancelAnimationFrame(resizeFrame);

      window.removeEventListener('resize', onResize);

      groupData.forEach(function (data) {
        if (data.observer) data.observer.disconnect();

        removeConnectors(data.cards);

        data.group.style.removeProperty('grid-template-columns');
        data.group.style.removeProperty('row-gap');

        data.cards.forEach(function (card) {
          if (card.dataset.stepPositionAdded === 'true') {
            card.style.removeProperty('position');
            delete card.dataset.stepPositionAdded;
          }
        });
      });

      initializedSections.delete(section);
    });
  }

  function initAllSections() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  addStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections, {
      once: true
    });
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target;

    if (section.matches && section.matches(SECTION_SELECTOR)) {
      initSection(section);
    } else if (section.querySelectorAll) {
      section.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const cleanup = initializedSections.get(event.target);
    if (cleanup) cleanup();
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    document.querySelectorAll('.ts7-micro_phone__button')
      .forEach(function (el) {
        el.setAttribute('aria-label', 'Search by voice');
      });
  }, 500);
});
document.addEventListener('DOMContentLoaded', function () {
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (element) {
          element.textContent = cart.item_count;
        });

        document.querySelectorAll('.cart-link__bubble').forEach(function (bubble) {
          if (cart.item_count > 0) {
            bubble.classList.add('cart-link__bubble--visible');
          } else {
            bubble.classList.remove('cart-link__bubble--visible');
          }
        });
      })
      .catch(function (error) {
        console.error('Cart count error:', error);
      });
  }

  /* Initial count */
  updateCartCount();

  /* Shopify AJAX fetch */
  const originalFetch = window.fetch;

  window.fetch = function () {
    const args = arguments;

    return originalFetch.apply(this, args).then(function (response) {
      const requestUrl =
        typeof args[0] === 'string'
          ? args[0]
          : args[0] && args[0].url
            ? args[0].url
            : '';

      if (
        requestUrl.includes('/cart/add') ||
        requestUrl.includes('/cart/change') ||
        requestUrl.includes('/cart/update') ||
        requestUrl.includes('/cart/clear')
      ) {
        setTimeout(updateCartCount, 50);
      }

      return response;
    });
  };

  /* Shopify AJAX XMLHttpRequest */
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._cartRequestUrl = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    const xhr = this;

    xhr.addEventListener('load', function () {
      const url = xhr._cartRequestUrl || '';

      if (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      ) {
        setTimeout(updateCartCount, 50);
      }
    });

    return originalSend.apply(this, arguments);
  };
});



